import React from "react";
import { NavLink, useLocation } from "react-router-dom";

// Same Open Market / Closed Market toggle Seller Central puts above its tabs.
export default function MarketSwitcher() {
	const { pathname } = useLocation();
	const closed = pathname.startsWith("/closed-market");
	return (
		<div className="segmented mb-3">
			<NavLink to="/orders" className={`segmented-btn${!closed ? " active" : ""}`}>
				Open market
			</NavLink>
			<NavLink to="/closed-market" className={`segmented-btn${closed ? " active" : ""}`}>
				Closed market
			</NavLink>
		</div>
	);
}
